import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Input
} from '@chakra-ui/react';

const Budget = ({ 
  budget = '', 
  onBudgetChange = () => {},
  onKeyPress = () => {}
}) => {
  const [budgetValue, setBudgetValue] = useState(budget);

  useEffect(() => {
    setBudgetValue(budget);
  }, [budget]);

  const handleChange = (e) => {
    const value = e.target.value;
    setBudgetValue(value);
    onBudgetChange(value);
  };

  return (
    <Box className="w-full">
      <Text 
        className="block font-medium text-amber-800 mb-3 text-center"
        fontSize="md"
      >
        Budget:
      </Text>
      <Box className="relative w-full">
        <Box className="absolute left-4 top-1/2 transform -translate-y-1/2 text-amber-700 font-semibold text-xl z-10 pointer-events-none">
          $
        </Box>
        <Input
          type="number"
          value={budgetValue}
          onChange={handleChange}
          onKeyPress={onKeyPress}
          placeholder="Tell us your budget!"
          min="1"
          required
          className="text-center font-semibold text-xl bg-amber-50 border-2 border-orange-200 rounded-xl 
                   focus:border-rose-400 focus:ring-2 focus:ring-rose-100 transition-all duration-300
                   hover:border-orange-300 pl-10 text-stone-800"
          size="lg"
          fontSize="xl"
          fontWeight="600"
        />
      </Box>
    </Box>
  );
};

export default Budget;